/**
 * @generated SignedSource<<6fe5c76d8b0a53ecc34861a605e837ea>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteriorsLandingProjectItem_projectModule$data = {
  readonly designFirm: {
    readonly directoryProfile: {
      readonly profilePhoto: string | null;
    } | null;
    readonly name: string | null;
    readonly publicProfile: {
      readonly urlLabel: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly imageUrl: string | null;
  readonly project: {
    readonly name: string | null;
    readonly serviceId: string | null;
    readonly url: string | null;
  } | null;
  readonly " $fragmentType": "InteriorsLandingProjectItem_projectModule";
};
export type InteriorsLandingProjectItem_projectModule$key = {
  readonly " $data"?: InteriorsLandingProjectItem_projectModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteriorsLandingProjectItem_projectModule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteriorsLandingProjectItem_projectModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "designProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DirectoryDesignFirm",
      "kind": "LinkedField",
      "name": "designFirm",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmDirectoryProfile",
          "kind": "LinkedField",
          "name": "directoryProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profilePhoto",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignFirmPublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    }
  ],
  "type": "InteriorsLandingModuleItem",
  "abstractKey": null
};
})();

(node as any).hash = "92528491491c0ccdafaeba07ab37d33f";

export default node;
